import { gql } from '@apollo/client';

export const DeletePersons = gql`
  mutation DeletePersons($personIds: [String], $filter: String) {
    deletePersons(personIdentifiers: $personIds, filter: $filter)
  }
`;
